@if (event) {
  <app-event-bar [event]="event"></app-event-bar>
}
<div class="container pb-4 pt-4 ">
  <h1 class="d-none d-md-block">
    Bienvenue sur votre Portail client
  </h1>
  <h1 class="d-block d-md-none">
    Portail client Libriciel
  </h1>

  <div class="dashboard-grid">
    <div class="d-flex flex-column">
      <app-dash-block-infos></app-dash-block-infos>
      @if (rolesService.hasProduct()) {
        <app-dash-block-tickets></app-dash-block-tickets>
      }
      <app-dash-block-faq></app-dash-block-faq>
      <app-dash-block-rn></app-dash-block-rn>
      <app-dash-block-favorites></app-dash-block-favorites>
    </div>
    <div class="d-none d-md-flex flex-column">
      <app-dash-block-commercial showTooltip="true"></app-dash-block-commercial>
      <app-dash-block-dp (hasDpEvent)="hasDp = $event" [hidden]="true" showTooltip="true"></app-dash-block-dp>
      <app-dash-block-cdt></app-dash-block-cdt>
      @if (rolesService.isReferent() && rolesService.hasProduct()) {
        <app-dash-block-prestations
        ></app-dash-block-prestations>
      }
      <app-dash-block-news class="d-none"></app-dash-block-news>
    </div>
  </div>
</div>

